import { c as classNames } from '../../shared/bind-d9144132.js';
import { interpolateWithHtml } from '../../utils/interpolateWithHtml.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "note": "web_ui__Note__note",
  "default": "web_ui__Note__default",
  "narrow": "web_ui__Note__narrow",
  "wide": "web_ui__Note__wide",
  "inverse": "web_ui__Note__inverse",
  "left": "web_ui__Note__left",
  "center": "web_ui__Note__center",
  "right": "web_ui__Note__right"
};

var Styling = /*#__PURE__*/function (Styling) {
  Styling["Default"] = "default";
  Styling["Narrow"] = "narrow";
  Styling["Wide"] = "wide";
  return Styling;
}(Styling || {});
var Alignment = /*#__PURE__*/function (Alignment) {
  Alignment["Left"] = "left";
  Alignment["Center"] = "center";
  Alignment["Right"] = "right";
  return Alignment;
}(Alignment || {});
var cssClasses = classNames.bind(styles);
var Note = function Note(_ref) {
  var text = _ref.text,
    _ref$styling = _ref.styling,
    styling = _ref$styling === void 0 ? Styling.Default : _ref$styling,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? Alignment.Left : _ref$alignment,
    inverse = _ref.inverse,
    html = _ref.html,
    testId = _ref.testId;
  var noteClass = cssClasses(styles.note, styling, alignment, {
    inverse: inverse
  });
  var element = /*#__PURE__*/jsx("div", {
    className: noteClass,
    "data-testid": testId,
    children: text
  });
  if (html) return interpolateWithHtml(element);
  return element;
};
Note.Styling = Styling;
Note.Alignment = Alignment;

export { Note as default };
//# sourceMappingURL=Note.js.map
